import React, {useState, useContext} from "react";
import __ from "lodash";
import moment from "moment";
import {Button, IconButton, Tooltip} from '@material-ui/core';
import {HighlightOff, Receipt, Search, Refresh} from '@material-ui/icons';
import {Stack} from "@mui/material";
import SystemContext from "../../../SystemContext";
import {ActionsList,ComboSelect, DatePicker, MaskedNumber} from "../../../controls";
import CompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";

const dateFormat = "DD/MM/YYYY";
const marginLeft = 10;

const AwbStockSelector = (_props) => {
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  const props = {
    ..._props
  }
  const {classes} = props;
  const externalCompany = __.has(props, "company") && !__.isEmpty(props.company);
  const emptySearch = {
    fromDate: null,
    toDate: null,
    awbPrefix: "",
    awbSerial: "",
    companyUuid:  externalCompany ? props.company?.companyUuid : "",
  }

  const [search, setSearch] = useState(props.searchCriteria ?? emptySearch);

  const handleSearch = () => {
    if (eventBus) {
      eventBus.trigger('AwbStockAllocationsList.search',
        {
          fromDate: search.fromDate ? moment(search.fromDate).format("YYYY-MM-DD") : null,
          toDate: search.toDate ? moment(search.toDate).format("YYYY-MM-DD") : null,
          awbPrefix: search.awbPrefix||"null",
          awbSerial: search.awbSerial||"null",
          companyUuid: search.companyUuid ||"null",
        }
      );
    }
  }

  const handleClearSelections = () => {
    setSearch(emptySearch);
    if (eventBus) {
      eventBus.trigger('AwbStockAllocationsList.search', {});
      eventBus.trigger('AwbAllocatedStockList.search', {});
    }
  }

  const handleNewAllocation = () => {
    if (eventBus) {
      eventBus.trigger('AllocateCompanyStockDialog.open', {title: "Allocate new AWB Stock", canEdit: props.canEdit, currentAllocation: {}});
    }
  }

  const actions = [
    {iconName: "receipt", iconProps: {color: "secondary"}, tooltip: "Allocate new Stock to Client Company", disabled: !props.canEdit, onClick:()=>{handleNewAllocation()}}
  ]

  const handleRefresh = () => {
    if (eventBus) {
      eventBus.trigger('AwbStockAllocationsList.refresh');
    }
  }

  if (externalCompany) {
    handleSearch();
  }


  return (
    <div style={{padding: "10px 20px", alignItems: "center",  justifyContent: "center",  width: "calc(100% - 20px)", display: "flex"}}>
      <ComboSelect
        style={{width: 100}}
        containerStyle={{width: 100}}
        label="Stock"
        inputLabelProps={{ shrink: true }}
        group="AWB STOCK"
        subGroup="PREFIX"
        value={search.awbPrefix}
        onChange={(value)=> {console.log(value); setSearch({...search, awbPrefix: value})}}
      />
      <div style={{width: 100, paddingLeft: 10}}>
        <MaskedNumber
          value={search.awbSerial}
          label="AWB Serial"
          inputLabelProps={{ shrink: true }}
          decimalScale={0}
          fixedDecimalScale={true}
          thousandsGroupStyle=""
          thousandSeparator=""
          valueCap={99999999}
          allowLeadingZeros={true}
          format="########"
          // disabled={!search.awbPrefix}
          onChange={(value)=> {setSearch({...search, awbSerial: value})}}
        />
      </div>
      <DatePicker
        style={{width: 130, marginTop: -1, marginLeft: marginLeft}}
        value={search.fromDate}
        defaultValue={null}
        disableToolbar={true}
        label={"From Date"}
        autoOk={true}
        format={dateFormat}
        onChange={(value)=> {
          const fromDate = moment(value).toISOString();
          setSearch({...search, fromDate: fromDate});
        }}
      />
      <DatePicker
        style={{width: 130, marginTop: -1, marginLeft: marginLeft}}
        label="To Date"
        value={search.toDate}
        defaultValue={null}
        disableToolbar={true}
        autoOk={true}
        format={dateFormat}
        onChange={(value)=> {
          const toDate = moment(value).toISOString();
          setSearch({...search, toDate: toDate});
        }}
      />
      <div style={{width: 300, marginLeft: marginLeft, marginRight: marginLeft, marginTop: -2, display: `${externalCompany ? "none" : "inherit"}`}}>
        <CompanyUuidLookup
          label="Customer"
          companyType="CUSTOMER"
          value={search.companyUuid}
          atAirport={undefined}
          hideCode={true}
          shrink={true}
          disable={externalCompany}
          onChange={(value) => {
            setSearch({...search, companyUuid: value});
          }}
        />
      </div>
      <Stack direction="row" alignItems="center" spacing={0}>
        <IconButton onClick={()=>{handleSearch()}}>
          <Tooltip title={"Click to retrieve allocations"}>
            <Search style={{height: 32, width: 32, }} color="primary"/>
          </Tooltip>
        </IconButton>
        <IconButton onClick={()=>{handleClearSelections()}}>
          <Tooltip title={"Click to clear all selections"}>
            <HighlightOff style={{height: 32, width: 32, }} color="primary"/>
          </Tooltip>
        </IconButton>
        <IconButton onClick={()=>{handleRefresh()}}>
          <Tooltip title={"Refresh"}>
            <Refresh style={{height: 32, width: 32, }} color="primary"/>
          </Tooltip>
        </IconButton>
      </Stack>
      <div style={{display: `${externalCompany ? "none" : "block"}`, marginLeft: "auto", marginRight: "0"}}>
        <Tooltip title={"Allocate new Stock to Client Company"}>
          <Button
            style={{marginRight: 20}}
            startIcon={<Receipt />}
            color={"primary"}
            variant={"contained"}
            onClick={()=>{handleNewAllocation()}}
          >
            Allocate Stock
          </Button>
        </Tooltip>
      </div>
      {/*<div style={{ display: "block", marginLeft: "auto", marginRight: "0"}}>*/}
      {/*  <ActionsList*/}
      {/*    id={"action-list"}*/}
      {/*    actions={actions}*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  )
}

export default AwbStockSelector;
